import t from 'react-translate';
import { IntegrationAuth } from 'redux/schemas/models/mentoring-program-sessions';

import { css } from '@emotion/react';
import { gray2, gray4, gray7 } from 'styles/global_defaults/colors';

import useCalendarIntegration from 'athena/hooks/use-calendar-integration';
import VirtualMeetingButton from './virtual-meeting-button';

const styles = css`
  .virtual-meeting-title {
    i {
      cursor: pointer;
      color: ${gray4};
    }
  }
  .settings {
    &:hover {
      background-color: ${gray7};
      border-radius: 100px;
      i {
        color: ${gray2};
      }
    }
  }
`;

type VirtualMeetingProps = {
  integrations: IntegrationAuth;
  openIntegrationsModal?: () => void;
};

const VirtualMeeting = (props: VirtualMeetingProps) => {
  const { integrations, openIntegrationsModal } = props;
  const { source = [] } = integrations || {};

  const translations = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.VIRTUAL_MEETING;

  const {
    needsReauthentication,
    isOnlyCalendarIntegration: isOnlyCalendarIntegrationMissing,
    isOnlyCalendarIntegrationEnabled,
  } = useCalendarIntegration(source);

  return (
    <>
      <div
        css={styles}
        className='virtual-meeting d-flex justify-content-between align-items-center mb-4'
      >
        {(isOnlyCalendarIntegrationMissing || (isOnlyCalendarIntegrationEnabled && needsReauthentication)) ? (
          <div className='d-flex text-regular session-time virtual-meeting-title align-items-center'>
            {translations.MS_CALENDAR_TITLE()}
          </div>
        ) : (
          <div className='d-flex text-regular session-time virtual-meeting-title align-items-center'>
            {translations.TITLE()}
          </div>
        )}

        <VirtualMeetingButton
          integrations={integrations}
          openIntegrationsModal={openIntegrationsModal}
        />
      </div>
    </>
  );
};

export default VirtualMeeting;
